import type { ReactNode } from 'react';
import { Box } from '@simplywallst/ui-core';

type Props = {
  children: ReactNode;
};
export const Footer = ({ children }: Props) => {
  return (
    <Box position="absolute" bottom="0" width="100%">
      {children}
    </Box>
  );
};
